import React from 'react';
import { formatMoney } from '../../util/currency';

import css from './OrderBreakdown.module.css';

/**
 * Renders the cancellation fee line item.
 * Only appears on cancelled transactions where a partial fee was retained.
 */
const LineItemCancellationFeeMaybe = props => {
  const { lineItems, intl } = props;
  const item = lineItems.find(i => i.code === 'line-item/cancellation-fee' && !i.reversal);

  if (!item || item.lineTotal?.amount === 0) return null;

  const label = intl.formatMessage({ id: 'OrderBreakdown.cancellationFee' });
  const formattedTotal = formatMoney(intl, item.lineTotal);

  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>{label}</span>
      <span className={css.itemValue}>{formattedTotal}</span>
    </div>
  );
};

export default LineItemCancellationFeeMaybe;
